// @ts-check

const { ExtendableError } = require('shared/error-utils')

//

class CanceledPromiseError extends ExtendableError {
  constructor(message = 'Promise has been canceled') {
    super(message)
    this.isCanceled = true
  }
}

/**
 * @typedef {Object} CancelablePromiseWrapper
 * @property {Promise.<any>} promise
 * @property {() => void} cancel
 * @property {() => Promise.<void>} waitUntilSettled
 */

/**
 * Wraps a Promise so that it can be canceled
 * @see https://github.com/facebook/react/issues/5465#issuecomment-157888325
 * @param {Promise.<any>} originalPromise
 * @returns {CancelablePromiseWrapper}
 */
function makePromiseCancelable(originalPromise) {
  /** @type {Error | void} */
  let canceled
  const wrappedPromise = new Promise((resolve, reject) => {
    originalPromise
    .then(val => canceled ? reject(canceled) : resolve(val))
    .catch(err => canceled ? reject(canceled) : reject(err))
  })
  return {
    promise: wrappedPromise,
    cancel() {
      // Prefer the original cancellation for multiple cancels
      canceled = canceled || new CanceledPromiseError()
    },
    waitUntilSettled() {
      return wrappedPromise.then(() => {}).catch(() => {})
    }
  }
}

module.exports = {
  CanceledPromiseError,
  makePromiseCancelable
}
